(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.Millennium",
            {
                url: "/Millennium",
                component: "millennium",
                PageTitle: "Millennium",
                requiredPermissions: "Millennium:View",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("millennium",
    {
        templateUrl: "App/Resources/Millennium/millennium.html",
        controller: millenniumCtrl,
        bindings: {
            states: "<"
        }
    });

    millenniumCtrl.$inject = ["$mdDialog", "$http", "$filter", "eligibilityFormDialog", "surveys", "eligibilityFormApi", "purchaseApi", "wistiaApi", "permissionService", "amplitudeService"];

    function millenniumCtrl($mdDialog, $http, $filter, eligibilityFormDialog, surveys, eligibilityFormApi, purchaseApi, wistiaApi, permissionService, amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        surveys.then(function (s) {
            eligibilityFormApi.isEnrolled(s.milleniumId).then(function (response) {
                $ctrl.submitted = response;
            });
        });

        $ctrl.loadResources = function () {
            
            $ctrl.loadingAssets = true;
            wistiaApi.getMillenniumAssets().then(function (response) {

                var projectMedias = response.medias;
                $ctrl.Assets = [];

                var uniqueMedias = $filter("unique")(projectMedias, "section");
                ng.forEach(uniqueMedias, function (value, key) {
                    var newAsset =
                    {
                        Title: value.section,
                        Active: uniqueMedias.length > 1 ? true : false,
                        Medias: ($filter("filter")(projectMedias, { section: value.section }))
                    }
                    $ctrl.Assets.push(newAsset);
                });

                //custom asset section linked below

                var customSection = {
                    Title: "Related Articles",
                    Active: false,
                    Medias: [
                        {
                            url: "http://www.cnbc.com/2016/05/01/lousy-401k-plans-may-spark-more-lawsuits.html",
                            name: "Lousy 401(k) Plans May Spark More Lawsuits",
                            type: "html"
                        },
                        {
                            url: "http://www.marketwatch.com/story/maybe-you-should-sue-your-401k-sponsor-2015-03-28",
                            name: "Maybe You Should Sue Your 401(k) Sponsor",
                            type: "html"
                        },
                        {
                            url: "http://www.nytimes.com/2016/08/10/your-money/mit-nyu-yale-sued-4013b-retirement-plan-fees-tiaa-fidelity.html?_r=1",
                            name: "M.I.T., N.Y.U. and Yale Are Sued Over Retirement Plan Fees",
                            type: "html"
                        },
                        {
                            url: "https://www.bna.com/emory-first-college-n73014450822/#!",
                            name: "Emory is First College to Lose Retirement Plan Lawsuits",
                            type: "html"
                        },
                        {
                            url: "https://www.bna.com/duke-second-school-n73014450919/#!",
                            name: "Duke Is Second School to Lose Round in Retirement Plan Lawsuits",
                            type: "html"
                        },
                        {
                            url: "https://www.bna.com/university-chicago-latest-n73014451368/",
                            name: "University of Chicago Latest College Hit With Retirement Plan Suit",
                            type: "html"
                        },
                        {
                            url: "http://www.cnbc.com/2016/08/15/college-retirement-plans-face-a-new-wave-of-lawsuits.html",
                            name: "College retirement plans face a new wave of lawsuits. Are your 403(b) fees too high?",
                            type: "html"
                        },
                        {
                            url: "https://www.wsj.com/articles/suits-target-university-retirement-plans-1471647814",
                            name: "Suits Target University Retirement Plans. Lawsuits contend some universities’ 403(b)s are slow to streamline retirement-plan choices and to lower fees",
                            type: "html"
                        }
                        ,
                        {
                            url: "https://www.insidehighered.com/news/2016/08/18/retirement-plan-lawsuits-could-be-just-beginning",
                            name: "Retirement Plan Roulette",
                            type: "html"
                        }
                        ,
                        {
                            url: "https://finance.yahoo.com/news/top-colleges-face-lawsuits-over-135529098.html",
                            name: "Top colleges face lawsuits over retirement-plan fees",
                            type: "html"
                        }
                    ]
                }
                $ctrl.Assets.push(customSection);

            }).then($ctrl.loadingAssets = false);
        }     
     
        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.milleniumId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }        

        if (permissionService.hasOnePermission("Millennium:Access")) {
            $ctrl.loadResources();
        }  
    }
})(window.app, window.angular); // jshint ignore:line